import { filter, map, some } from 'lodash';
import { PROFILE_WORKOUT } from '../../constants';

export const SpeechBubbleWorkout = {
  transclude: true,

  bindings: {
    form: '<',
    member: '<',
    scrollTo: '&',
    onComplete: '&',
    onUpdate: '&',
  },

  template: `
    <div class="speech-bubble-nutrition py-4 bg-white">
      <div class="speech-bubble-step">
        <speech-bubble class="fade-in-1">
          Now let's set up your workout profile by answering 3 easy questions.
        </speech-bubble>
      </div>
      <div class="pt-1" id="scroll-{{ $index }}"
        ng-repeat="item in $ctrl.questions track by $index">
        <div class="speech-bubble-step"
          ng-if="$ctrl.index >= $index">
          <speech-bubble class="fade-in-1"
            ng-if="$index === 1">
            Great!
          </speech-bubble>
          <speech-bubble
            ng-class="{
              'fade-in-2': ($index <= 1) && ($ctrl.index === $index),
              'fade-in-1': ($index > 1) && ($ctrl.index === $index)
            }">
            <strong>{{ item.question }}</strong>
          </speech-bubble>
          <speech-bubble class="text-right"
            is-answer="true"
            ng-hide="item.isActive">
            {{ item.answer || 'None Selected' }}
          </speech-bubble>
          <div class="speech-bubble-row text-right"
            ng-hide="item.isActive">
            <button class="btn btn-link"
              type="button"
              ng-click="item.isActive = true">
              Change
            </button>
          </div>
          <div class="speech-bubble-row pt-3"
            ng-show="item.isActive"
            ng-class="{
              'fade-in-3': ($index <= 1) && ($ctrl.index === $index),
              'fade-in-2': ($index > 1) && ($ctrl.index === $index)
            }">
            <form-fieldset
              form="$ctrl.form"
              name="item.key"
              key="voomeProfile.preferences.{{ item.key }}"
              list="$ctrl.member.voomeProfile.preferences[item.key]"
              type="{{ item.type }}"
              on-update="$ctrl.onUpdate({ key: key, value: value })">
            </form-fieldset>
          </div>
          <div class="speech-bubble-row full-width"
            ng-class="{
              'fade-in-4': ($index <= 1) && ($ctrl.index === $index),
              'fade-in-3': ($index > 1) && ($ctrl.index === $index)
            }">
            <button class="btn-link btn-continue"
              type="button"
              ng-click="$ctrl.onClick($index, item)"
              ng-disabled="$ctrl.isDisabled(item.key)"
              ng-show="item.isActive">
              <span>Continue</span>
            </button>
          </div>
        </div>
      </div>
      <div class="speech-bubble-step fade-in-1"
        ng-if="$ctrl.index >= $ctrl.questions.length">
        <speech-bubble>
          Great, we have everything we need for your workout profile.
        </speech-bubble>
      </div>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        this.index = 0;
        this.questions = this.reduceQuestions(PROFILE_WORKOUT);
      },

      reduceQuestions(questions) {
        return questions.map((item, index) => {
          return {
            ...item,
            isActive: index === this.index,
            answer: this.answersAsString(item.key),
          };
        });
      },

      answersAsString(key) {
        const answers = map(
          filter(this.member.voomeProfile.preferences[key], 'active'),
          'name'
        );

        return answers
          ? answers.length > 1 ? answers.join(', ') : answers[0]
          : null;
      },

      onClick($index, item) {
        if ($index <= this.index) {
          this.index = $index + 1;
          this.scrollTo({ id: `scroll-${this.index}` });
        }

        if ($index >= this.questions.length - 1) {
          $timeout(() => this.onComplete(), 1000);
        }

        this.questions = this.reduceQuestions(this.questions);
      },

      isDisabled(key) {
        return !some(this.member.voomeProfile.preferences[key], 'active');
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/SpeechBubble/SpeechBubbleWorkout.js